export type Language = 'fr' | 'en';
export type Translate = (french: string, english: string) => string;

const STORAGE_KEY = 'ig_language';
const listeners = new Set<() => void>();

function readLanguage(): Language {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'en' ? 'en' : 'fr';
  } catch {
    return 'fr';
  }
}

let language = readLanguage();

function updateDocumentLanguage() {
  if (typeof document !== 'undefined') document.documentElement.lang = language;
}

updateDocumentLanguage();

export function getLanguage(): Language {
  return language;
}

export function getLocale(): string {
  return language === 'en' ? 'en-US' : 'fr-FR';
}

export function setLanguage(next: Language): void {
  if (next !== 'fr' && next !== 'en') return;
  language = next;
  updateDocumentLanguage();
  try {
    window.localStorage.setItem(STORAGE_KEY, next);
  } catch {
    // A blocked or full storage must not prevent changing the interface language.
  }
  listeners.forEach((listener) => listener());
}

export function subscribeLanguage(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

// For non-React callbacks (toasts, errors, formatters), read the language at call time.
export const translate: Translate = (french, english) => (language === 'en' ? english : french);
